import React from "react";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import Checkbox from "components/Common/Checkbox/Checkbox";
import ProjectSelect from "components/Select/Project";
import { RcFile } from "antd/es/upload/interface"; // ✅ Import RcFile
import SavedSearchSelect from "components/Select/SavedSearch";
import { message, UploadProps } from "antd";
import UploadFile from "components/Common/Input/UploadFile";
import HandleProjectSelect from "./HandleProjectSelect";
import { uploadJobDescription } from "api/search.api";
import { replaceSearchBy } from "store/slices/searcSlice";
import { useDispatch } from "react-redux";
import { processCompanyData } from "components/AIQuestionSearch/SearchQuestionMain";

const InsertProjectInformationForm = () => {
  const [selectedOption, setSelectedOption] = React.useState<string | null>("uploadFile");
  const dispatch = useDispatch();

  const handleSetValuesInRedux = (searchConfig: any) => {
    if (searchConfig) {
      const booleanSearchParsedData = searchConfig;

      dispatch(
        replaceSearchBy({
          jobTitle: booleanSearchParsedData.jobTitles,
          includeLocations: booleanSearchParsedData.locations,
          excludeLocations: booleanSearchParsedData.locationsExclude,
          includeCompanies: processCompanyData(booleanSearchParsedData.companies),
          excludeCompany: booleanSearchParsedData.companiesExclude,
          keywords: booleanSearchParsedData.keywords,
          minExp: booleanSearchParsedData.experienceMin ? booleanSearchParsedData.experienceMin : 1,
          maxExp: booleanSearchParsedData.experienceMax
            ? booleanSearchParsedData.experienceMax
            : 60,
        })
      );
    }
  };
  const props: UploadProps = {
    name: "file",
    multiple: true,
    customRequest: async ({ file, onSuccess, onError }) => {
      const formData = new FormData();
      formData.append("file", file as RcFile); // ✅ Ensuring file is of type RcFile

      try {
        const response = await uploadJobDescription(formData);
        onSuccess?.(response, file as any);
        message.success(`Successfully imported candidate configuration.`);
        handleSetValuesInRedux(response?.data?.searchConfigGenerator);
      } catch (error) {
        onError?.(error as ProgressEvent<EventTarget>); // ✅ Ensuring correct error type
        message.error(`${(file as RcFile).name} upload failed.`);
      }
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  return (
    <>
      <div className="w-1/4">
        <SectionTitleAndDescription
          title="Insert information from"
          isRequiredSection={false}
          isHelpInfoReq={false}
        />
      </div>

      <div className="w-3/4 ">
        {/* <div className=" xl:flex grid gap-4 items-center  ">
          <Checkbox
            inputId="industry"
            inputName="industry"
            inputValue=""
            checked={selectedOption === "project"}
            labelFor="Project"
            labelTitle="Project"
            onChange={() => setSelectedOption("project")}
          />
          <Checkbox
            inputId="industryLeader"
            inputName="industryLeader"
            inputValue=""
            checked={selectedOption === "savedSearch"}
            labelFor="Saved Search"
            labelTitle="Saved Search"
            onChange={() => setSelectedOption("savedSearch")}
          />
          <Checkbox
            inputId="segment"
            inputName="Segment"
            checked={selectedOption === "filterTemplate"}
            inputValue=""
            labelFor="Filter Template"
            labelTitle="Filter Template"
            onChange={() => setSelectedOption("filterTemplate")}
          />
          <Checkbox
            inputId="segment"
            inputName="Upload File"
            checked={selectedOption === "uploadFile"}
            inputValue=""
            labelFor="Upload File"
            labelTitle="Upload File"
            onChange={() => setSelectedOption("uploadFile")}
          />
        </div> */}
        <div>
          {selectedOption === "project" ? (
            <div className="mt-10 w-full">
              <HandleProjectSelect />
            </div>
          ) : null}
          {selectedOption === "savedSearch" ? (
            <div className="mt-10">
              <SavedSearchSelect></SavedSearchSelect>
            </div>
          ) : null}
          {/* {selectedOption === "filterTemplate" ? <FilterTemplateSelect></FilterTemplateSelect> : null} */}
          {selectedOption === "uploadFile" ? (
            <div className="mt-1">
              {" "}
              <UploadFile
                {...props}
                secText="  Support for a single or bulk upload. Strictly prohibited from uploading company data
                or other banned files."
              />
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default InsertProjectInformationForm;
